<div [title]="communityStatus">
    <div *ngIf="linkEnabled">
        <app-hyperlink-creator
            cssClass="cc-hyperlink-hover"
            mode="hyperlinkOnly"
            [title]="hyperlinkTitle"
            [communityId]="communityId"
            [customerId]="customerId"
            (onLinkClick)="onLinkClick()"
        >
            <ng-container [ngTemplateOutlet]="displayTextTemplate"></ng-container>
        </app-hyperlink-creator>
    </div>
    <div *ngIf="!linkEnabled">
        <ng-container [ngTemplateOutlet]="displayTextTemplate"></ng-container>
    </div>
</div>

<ng-template #displayTextTemplate>
    <span>
        <span
            *ngIf="!customerId"
            [ngClass]="{
                'cc-community-intransition': communityStatus === 'InTransition' && !communityTerminatingDate,
                'cc-community-terminated': communityStatus === 'Terminated',
                'cc-community-terminating': communityStatus !== 'Terminated' && !!communityTerminatingDate
            }"
        >
            <i
                *ngIf="!communityTerminatingDate && communityStatus === 'InTransition'"
                [ngClass]="iconTransition"
                aria-hidden="true"
                [title]="getStatus()"
            ></i>
            <i
                *ngIf="communityStatus === 'Terminated'"
                [ngClass]="iconTerminate"
                aria-hidden="true"
                [title]="getStatus()"
            ></i>
            <i
                *ngIf="communityStatus !== 'Terminated' && !!communityTerminatingDate"
                [ngClass]="iconExclamatory"
                aria-hidden="true"
                [title]="getStatus()"
            ></i>
        </span>
        {{ displayText }}
    </span>
</ng-template>
